import React from 'react';
import {Box, Center, Container, Link, Text} from "@chakra-ui/react";
import SvgLocationFooter from "../../../assets/svg/SvgLocationFooter";
import {ADDRESS, MOTION_WHATSAPP_LINK} from "../../../helpers/adminData";

const Footer = () => {
    return (
        <Box bg="#1F1F1F" >
            <Container maxW="container.xl" pt="10px" pb="11px" display="flex" justifyContent="space-between" alignItems="center" flexDir={{base: "column", md: "row"}}>
                <Center fontFammily='Raleway' fontWeight="400" fontSize="12px" color="#ffffff" opacity="0.5">
                    <Text>© 2023 «Пром Сталь». Все права защищены</Text>
                    <Link href={MOTION_WHATSAPP_LINK} target='_blank'>
                        <Text display={{base: "none", md: "block"}} ml="90px">Разработал Motion Web LLC </Text>
                    </Link>
                </Center>
                <Center fontFammily='Raleway' fontWeight="400" fontSize="12px" color="#ffffff" opacity="0.5">
                    <Text pt={{base:"12px",md:"0"}} pb={{base:"11px",md:"0"}}>Способ оплаты: Банковский перевод</Text>
                </Center>
                <Center pt={{base:"12px",md:"0"}} pb={{base:"31px",md:"0"}} fontFammily='Raleway' fontWeight="400" fontSize="12px" color="#ffffff">
                    <SvgLocationFooter/>
                    <Link href={`${ADDRESS}`} target='_blank'><Text opacity="0.5">г. К-Балта, Ул. Кожомбердиева-3</Text></Link>
                </Center>
                <Link href={MOTION_WHATSAPP_LINK} display={{base: "block", md: "none"}}>
                    <Text  textAlign="center" fontFammily='Raleway' fontWeight="400" fontSize="12px" color="#ffffff" opacity="0.5">Разработал Motion Web LLC </Text>
                </Link>
            </Container>
        </Box>
    );
};

export default Footer;
